/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';
import { ServiceError } from '../../services/service_base';

export const initialState = Immutable.fromJS({
  email: undefined,
  name: undefined,
  headline: undefined,
  loggedIn: false,
  confirmed: false,
  error: undefined,
  loading: false,
  tacksCount: 0,
  activeTacksCount: 0,
  finishedTacksCount: 0,
  queuedTacksCount: 0,
  pauseAll: false,
  slug: undefined,
  followsCount: 0,
  followersCount: 0,
  public: false,
  points: 0
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.USER_CONFIRMED:
      return state.merge({ confirmed: true });
    case types.USER_LOADING:
      return state.merge({ loading: true });
    case types.USER_LOGGED_IN:
      return state.merge({ ...action.user, loggedIn: true, loading: false });
    case types.USER_ACCOUNT_RETRIEVED:
      return state.merge({ ...action.user, loading: false });
    case types.USER_UPDATED:
      return state.merge({ ...action.user, loading: false })
    case types.USER_DELETED:
      return initialState;
    case types.USER_RESET:
      return initialState;
    case types.USER_LOGGED_OUT:
      return initialState;
    case types.ALL_TACKS_PAUSED:
      return state.merge({ pauseAll: true, loading: false });
    case types.ALL_TACKS_RESUMED:
      return state.merge({ pauseAll: false, loading: false });
    case types.USER_ERROR:
      const error = (action.error instanceof ServiceError) ? action.error.message : action.error;
      return state.merge({ error: error });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/user/reducer.js